window._klvReady = window._klvReady || [];
window._klvReady.push(function () {
  const KLEVU_RESULTS_LIMIT = 48;

  // Get footer height calculation
  let footerHeight = 0;
  window.klevu.each(
    document.querySelectorAll('.shopify-section-group-footer-group'),
    function (key, el) {
      footerHeight += el.offsetHeight;
    }
  );

  window.klevu({
    search: {
      infiniteScrollOffsetLanding: footerHeight ? footerHeight : 50, // setting to tell Klevu library when to load more results
    },
    theme: {
      modules: {
        resultInfiniteScroll: {
          quickSearch: { enable: true },
          searchResultsPage: {
            enable: true,
            containerSelector: '.kuResults',
          },
          categoryPage: { enable: true },
        },
      },
      setTemplates: {
        myCustomTemplateLanding: {
          scope: 'landing',
          selector: '#klevuLandingTemplateBaseCustom',
          name: 'klevuTemplateLanding',
        },
        myCustomProductBlock: {
          scope: 'landing,catnav',
          selector: '#klevuCustomProductBlock',
          name: 'productBlock',
        },
        myCustomQuickProductBlock: {
          scope: 'quick',
          selector: '#klevuQuickProductBlockCustom',
          name: 'klevuQuickProductBlock',
        },
      },
    },
  });

  // Search results page only: raise klevu_limit from 12 to 48 per product grid batch
  window.klevu.modifyRequest('landing', function (data, _scope) {
    window.klevu.each(data.request.current.recordQueries, function (_key, query) {
      if (window.klevu.getObjectPath(query, 'id') === 'productList') {
        window.klevu.setObjectPath(query, 'settings.limit', KLEVU_RESULTS_LIMIT);
      }
    });
  });

  // FIX: Quick Search term trimming
  window.klevu.beforeActivation('quick', function (data, scope) {
    window.klevu({
      search: {
        minChars: 1,
      },
    });
    window.klevu.setSetting(scope.kScope.settings, 'settings.search.minChars', 1);
    window.klevu.each(window.klevu.search.extraSearchBox, function (key, box) {
      box.getScope().chains.processors.inputString.add({
        name: 'checkLengthMin',
        fire: function (data, scope) {
          const minLength = window.klevu.getSetting(
            scope.kScope.settings,
            'settings.search.minChars',
            0
          );

          // trim spacing before and after the search term
          data.context.term = data.context.term.trim();

          if (data.context.term.length < minLength) {
            const chain = window.klevu.getObjectPath(scope.kScope, 'chains.template.handleError');
            if (!window.klevu.isUndefined(chain) && chain.list().length !== 0) {
              chain.setScope(scope.kElem);
              chain.setData({ section: 'inputString', sector: 'checkLength' });
              chain.fire();
            }
            data.context.preventDefault = true;
            document.body.click();
            return false;
          }
        },
      });
    });
  });

  window.klevu.beforeActivation('landing,catnav', function (data, scope) {
    scope.kScope.template.setTemplate('', 'pagination', true);

    // FIX: remove scroll to top code
    scope.kScope.chains.events.keyUp.remove({ name: 'scrollToTop' });
    window.klevuFinishedLoading = false;
    window.klevu.extensions.theme.module.attach('setRemoteConfigLanding', {
      name: 'fixInfiniteScroll',
      fire: function () {
        const hasInfiniteScrollEnabled = window.klevu.getGlobalSetting(
          'theme.modules.resultInfiniteScroll.searchResultsPage.enable',
          false
        );
        if (!hasInfiniteScrollEnabled) {
          return;
        }
        // Replace the buggy onscroll handler
        window.onscroll = function (_ev) {
          const landingOffset = parseInt(
            window.klevu.getSetting(
              window.klevu.search.landing.getScope().element.kScope.settings,
              'settings.search.infiniteScrollOffsetLanding',
              50
            )
          );
          // FIX: Use documentElement.scrollHeight instead of body.offsetHeight
          if (
            window.klevuFinishedLoading &&
            window.innerHeight + Math.ceil(window.pageYOffset) >=
              document.documentElement.scrollHeight - landingOffset
          ) {
            const hasAlreadyTriggered = window.klevu.getObjectPath(
              window.klevu.search.landing.getScope().data,
              'context.triggeredFromInfiniteScroll'
            );
            if (!hasAlreadyTriggered) {
              const target = window.klevu.getSetting(
                window.klevu.search.landing.getScope().settings,
                'settings.search.searchBoxTarget'
              );
              const activeQueryId = window.klevu.getObjectPath(
                window.klevu.search.landing.getScope().data,
                'context.activeQueryId'
              );
              if (activeQueryId) {
                const loadMoreBtns = window.klevu.dom.find(
                  '.' + activeQueryId + ' .kuLoadMoreBtn',
                  target
                );
                if (loadMoreBtns.length) {
                  window.klevuFinishedLoading = false;
                  loadMoreBtns[0].click();
                }
              }
            }
          }
        };
      },
    });
  });

  const SHOP_NAME = window.SHOP_NAME || '';

  window.klevu.afterTemplateRender('landing,catnav', async function (data, _scope) {
    // document.body.style.minHeight = '0';
    // const currentDocumentHeight = document.documentElement.scrollHeight;
    // document.body.style.minHeight = '${currentDocumentHeight}px';

    // FIX: Remove scroll to top behavior
    function setInfiniteScrollHeight() {
      window.klevuFinishedLoading = true;
      const currentDocumentHeight = document.documentElement.scrollHeight;
      document.body.style.minHeight = `${currentDocumentHeight}px`;

      // reset minHeight if there are Filters or Sorting have been selected
      function resetMinHeightListener(selector, matchSelector) {
        if (document.querySelector(selector) === null) {
          return;
        }
        document.querySelector(selector).addEventListener('click', function ({ target }) {
          if (target.matches(matchSelector)) {
            document.body.style.minHeight = '0';
          }
        });
      }

      // Call the function with different selectors and matchSelectors
      resetMinHeightListener(
        '.klevuLanding .kuFilters',
        '.kuFilterBox .kuFilterNames ul li a, .kuFilterBox .kuFilterNames ul li a *'
      );
      resetMinHeightListener(
        '.kuFilterTagsContainer',
        '.kuFilterTagValue, .kuFilterTagValue *, .kuFilterTagClearAll, .kuFilterTagClearAll *'
      );
      resetMinHeightListener(
        '.kuSearchResultsPageContainer .kuDropdown',
        '.kuSearchResultsPageContainer .kuDropdown .kuDropdownOptions .kuDropOption, .kuSearchResultsPageContainer .kuDropdown .kuDropdownOptions .kuDropOption *'
      );
    }
    setTimeout(setInfiniteScrollHeight, 1500);
    // END FIX

    try {
      const meta = data.template.query.productList.meta;
      if (!meta) return;

      const searchTerm = meta.searchedTerm;
      const totalResults = meta.totalResultsFound;
      const isLanding = window.klevu.getGlobalSetting('flags.setRemoteConfigLanding', false);

      if (isLanding && typeof searchTerm === 'string' && searchTerm.length >= 1) {
        document.title = `Search: ${totalResults} results found for "${searchTerm}" | ${SHOP_NAME}`;
        document.querySelectorAll('input[name="q"]').forEach(function (input) {
          input.value = searchTerm;
        });
      } else {
        document.title = `Search Result Page | ${SHOP_NAME}`;
      }

      const products = data.template.query.productList.result;

      for (const product of products) {
        const holder = document.querySelector('[data-id="' + product.id + '"] .kuProdWrapHolder');
        if (!holder || holder.dataset.loaded) continue;

        holder.dataset.loaded = 'true';

        fetch(product.url + '?view=klevu-template&variant=' + product.id)
          .then((res) => res.text())
          .then((html) => {
            // The template is a full document so the URL is valid on its own; only its
            // body belongs in the results grid.
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            holder.innerHTML = parsed.body ? parsed.body.innerHTML : html;
          });
      }

      document.querySelectorAll('.klevuProduct').forEach(function (el) {
        const id = el.getAttribute('data-id');

        const product = products.find((p) => String(p.id) === String(id));

        if (!product) return;

        let desc = product.description || product.desc || product.shortDesc || '';

        if (!desc) return;

        desc = desc.replace(/(<([^>]+)>)/gi, '').substring(0, 120) + '...';

        const descDiv = document.createElement('div');
        descDiv.className = 'kuProductDesc';
        descDiv.innerText = desc;

        const nameBlock = el.querySelector('.kuName');

        if (nameBlock && !el.querySelector('.kuProductDesc')) {
          nameBlock.insertAdjacentElement('afterend', descDiv);
        }
      });

      // if (window.jdgm) {
      //   jdgm.initializeWidgets();
      // }
    } catch (err) {
      console.error('Klevu render error:', err);
    }
  });

  let counter = 0;

  const quickChecker = setInterval(function () {
    const quickCheck1 = window.klevu.getObjectPath(
      window.klevu.settings,
      'flags.bindLocalBoxes.build',
      false
    );
    const quickCheck2 = window.klevu.getObjectPath(
      window.klevu.settings,
      'flags.setRemoteConfigQuick.loaded',
      false
    );
    const quickCheck3 = window.klevu.getObjectPath(
      window.klevu.settings,
      'flags.setRemoteConfigQuick.build',
      false
    );
    if (counter > 30 || (quickCheck1 && quickCheck2 && !quickCheck3)) {
      clearInterval(quickChecker);
      window.klevu.rebuild.quick();
    }
    if (quickCheck1 && quickCheck2 && quickCheck3) {
      clearInterval(quickChecker);
    }
    counter++;
  }, 200);
});

// ADA fix: remove empty h1 elements on the search results page as early as possible.
// Runs standalone, independent of Klevu load timing.
function removeEmptySearchPageHeadings() {
  const container = document.getElementById('search-page');
  if (!container) return;

  container.querySelectorAll('h1').forEach(function (heading) {
    if (heading.textContent.trim() === '') {
      heading.remove();
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', removeEmptySearchPageHeadings);
} else {
  removeEmptySearchPageHeadings();
}

function addAccessibleHighlightText() {
  const suggestionLinks = document.querySelectorAll('.klevuAutoSuggestionsWrap li a');

  suggestionLinks.forEach((link) => {
    if (link.innerHTML.includes('<b>') && !link.innerHTML.includes('sr-only')) {
      link.innerHTML = link.innerHTML.replaceAll(
        '<b>',
        '<span class="sr-only">Matched search term </span><b>'
      );
    }
  });
}

// Observe dynamic Klevu updates
const observer = new MutationObserver(() => {
  addAccessibleHighlightText();
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});
